export default __webpack_public_path__ + "static/media/archive-folder.10a7c6a7.svg";